import React from "react";

const Contact = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_11285_19609)">
        <path
          d="M16.99 3.5H7C4.79086 3.5 3 5.29086 3 7.5V16.5C3 18.7091 4.79086 20.5 7 20.5H16.99C19.1991 20.5 20.99 18.7091 20.99 16.5V7.5C20.99 5.29086 19.1991 3.5 16.99 3.5Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3 10.4902C3 11.1202 3.33 11.7002 3.87 12.0202L10.61 16.0402C11.46 16.5502 12.54 16.5502 13.39 16.0402L20.13 12.0202C20.67 11.7002 21 11.1202 21 10.4902"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_11285_19609">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Contact;
